<template>
    <svg class="fill-current text-brand-teal-light" width="165" height="12" viewBox="0 0 165 30" xmlns="http://www.w3.org/2000/svg">
        <circle cx="15" cy="15" r="15">
            <animate attributeName="r" from="12" to="12"
                begin="0s" dur="0.8s"
                values="12;15;12;9;12" calcMode="linear"
                repeatCount="indefinite" />
            <animate attributeName="fill-opacity" from="" to="1"
                begin="0s" dur="0.8s"
                values=".75;1;.75;.5;.75" calcMode="linear"
                repeatCount="indefinite" />
        </circle>

        <circle cx="60" cy="15" r="12" fill-opacity="0.3">
            <animate attributeName="r" from="9" to="9"
                begin="0s" dur="0.8s"
                values="9;12;15;12;9" calcMode="linear"
                repeatCount="indefinite" />
            <animate attributeName="fill-opacity" from="" to="1"
                begin="0s" dur="0.8s"
                values=".5;1;.5" calcMode="linear"
                repeatCount="indefinite" />
        </circle>

        <circle cx="105" cy="15" r="9">
            <animate attributeName="r" from="12" to="12"
                begin="0s" dur="0.8s"
                values="12;9;12;15;12" calcMode="linear"
                repeatCount="indefinite" />
            <animate attributeName="fill-opacity" from="0.66" to="0.66"
                begin="0s" dur="0.8s"
                values=".75;.5;.75;1;.75" calcMode="linear"
                repeatCount="indefinite" />
        </circle>

        <circle cx="150" cy="15" r="12">
            <animate attributeName="r" from="15" to="15"
                begin="0s" dur="0.8s"
                values="15;12;9;12;15" calcMode="linear"
                repeatCount="indefinite" />
            <animate attributeName="fill-opacity" from="1" to="1"
                begin="0s" dur="0.8s"
                values="1;.5;1" calcMode="linear"
                repeatCount="indefinite" />
        </circle>
    </svg>
</template>

<script>
    export default {}
</script>
